const borePumpTechnicianService = {
  title: "Bore / Pump Technician",
  icon: "💧",
  shortDescription:
    "Water pump checks, bore-related service visits, motor-side review, and installation support.",
  longDescription:
    "Book bore and pump support for water supply issues, pump inspection, basic fitting, and troubleshooting visits.",
  consultationNote:
    "Bore depth issues, rewinding, or major electrical-pump faults may need deeper inspection and specialized handling.",
  responsePromise:
    "Assignment depends on pump type, water setup, and technician availability.",
  warrantyPolicy:
    "Support depends on equipment condition, site access, and service scope.",
  subServices: [
    {
      id: "pump-motor-inspection",
      title: "Pump / Motor Inspection",
      icon: "⚙️",
      group: "Inspection",
      description:
        "Inspect pump not working, pressure issue, motor behavior, or water flow concern.",
      basePrice: 399,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "pump-install-assist",
      title: "Pump Installation Support",
      icon: "🧰",
      group: "Installation",
      description:
        "Basic support for pump fitting and setup where conditions are suitable.",
      basePrice: 999,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "water-supply-check",
      title: "Water Supply Line Check",
      icon: "🚿",
      group: "Troubleshooting",
      description:
        "Inspect line-side or delivery-side issue affecting water output.",
      basePrice: 349,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default borePumpTechnicianService;